<template>
  <v-container>
    <v-card>
      <v-card-title>Les descriptions</v-card-title>
      <v-card-text>
        <v-row class="my-4">
          <v-col cols="12">
            <v-text-field v-model="newDescription.title" label="Titre" outlined></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="newDescription.body" label="Value" outlined></v-text-field>
          </v-col>
          <v-col cols="10">
            <v-btn @click="addDescription" color="primary">Add Description</v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn @click="resetDescriptions()" color="error" class="ma-2">Reset</v-btn>
          </v-col>
        </v-row>
        <v-row v-for="(description, index) in descriptions" :key="index">
          <v-col cols="3">
            <v-text-field readonly disabled v-model="description.title" outlined></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="description.body" outlined></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn @click="updateDescription(description.title, description.body)" color="primary"  class="ma-2">Mettre à jour</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn @click="clearDescription(description.title)" color="warning" class="ma-2">Effacer</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn @click="deleteDescription(description.title)" color="error"  class="ma-2">Supprimer</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Description from "@/models/Description"

export default {
  data() {
    return {
      newDescription: {
        title: "",
        body: "",
      },
    }
  },
  computed: {
    descriptions() {
      return Description.query().all()
    },
  },
  methods: {
    async addDescription() {
      if (this.newDescription.title && this.newDescription.body) {
        await Description.createOrUpdateDescription(this.newDescription.title, this.newDescription.body)
        this.newDescription.title = ""
        this.newDescription.body = ""
      } else {
        alert("Please fill in both key and value fields.")
      }
    },
    async deleteDescription(title) {
      await Description.deleteDescription(title)
    },
    async clearDescription(title) {
      await Description.clearDescription(title)
    },
    async updateDescription(title, body) {
      await Description.createOrUpdateDescription(title, body)
    },
    async resetDescriptions() {
      await Description.resetDescriptions()
      await Description.getDescriptions()
    },
  },
}
</script>
